import React, {memo, Suspense, useState} from "react"
import {MANIFEST} from "@manifest/header"
import {useTemplatedComponent} from "@next/templating"
import {breakpoints} from "@next/ux-fabric"
import {SuggestionItem} from "../../models/autocomplete"
import connect from "./connect"
import {AUTOCOMPLETE_DEFAULT_ITEMS} from "../../config/constants"
import {AutocompleteMaxItemsConfig} from "../../models/search"

export type AutocompleteProps = {
    handleSuggestionClick: (suggestion: string, siteUrl: string) => void
    handleFocus?: (term: string, suggestion: string) => any
    suggestions: SuggestionItem[] | any
    term: string | any
    getConnectedPlpUrl: (suggestion: string, siteUrl: string) => string
    siteUrl: string
    showSelectionHighlight: boolean
    isSimple?: boolean
    autocompleteMaxItems: AutocompleteMaxItemsConfig
    templating: {
        mainTemplate: string
        fallbackTemplate: string
    }
}

export const Autocomplete = memo(
    ({
        handleSuggestionClick,
        handleFocus,
        suggestions,
        term,
        getConnectedPlpUrl,
        siteUrl,
        autocompleteMaxItems,
        showSelectionHighlight,
        isSimple = false,
        templating,
    }: AutocompleteProps) => {
        const [focusIndex, setFocusIndex] = useState(0)
        const getCurrentBreakpoint = () => {
            const windowWidth = window.innerWidth
            const breakpointsValues = Object.entries(breakpoints.values)
            let currentBreakpoint = "xxl"
            breakpointsValues.forEach(([key, value]) => {
                if (windowWidth >= value) {
                    currentBreakpoint = key
                }
            })
            return currentBreakpoint
        }

        const maxItems = autocompleteMaxItems[getCurrentBreakpoint()] || AUTOCOMPLETE_DEFAULT_ITEMS

        const filteredSuggestions = suggestions.slice(0, maxItems)

        const TemplatedAutocomplete = useTemplatedComponent(templating, MANIFEST)

        return (
            <Suspense>
                <TemplatedAutocomplete
                    handleSuggestionClick={handleSuggestionClick}
                    handleFocus={handleFocus}
                    suggestions={filteredSuggestions}
                    term={term}
                    getConnectedPlpUrl={getConnectedPlpUrl}
                    autocompleteMaxItems={autocompleteMaxItems}
                    showSelectionHighlight={showSelectionHighlight}
                    isSimple={isSimple}
                    siteUrl={siteUrl}
                />
            </Suspense>
        )
    },
)
Autocomplete.displayName = "Autocomplete"

export default connect(Autocomplete)
